import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { TemplateUtenteForm } from '../../../form/profili-utente/template-utente-form';
import { UtenteProfiloRequest } from '../../../models/dto/utente-profilo-request';
import { TemplateUtenteProfilo } from '../../../models/profili-utente/template-utente-profilo';
import { UtenteProfilo } from '../../../models/profili-utente/utente-profilo';

declare var closeModal: any;

@Component({
    selector: 'div [template-utente-add-form]',
  templateUrl: '../../../form/profili-utente/template-utente-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class TemplateUtenteAddComponent extends TemplateUtenteForm implements OnInit {

  templateUtente: TemplateUtenteProfilo;
  urlInsert: string;
  @Input() display: boolean;

 @Output() onReturn: EventEmitter<TemplateUtenteProfilo> = new EventEmitter<TemplateUtenteProfilo>();

  constructor(@Inject(OperationsService) operationService: OperationsService, @Inject(FormBuilder) campiForm: FormBuilder, @Inject(HelpersService) helpers: HelpersService) {
    super(operationService, campiForm, helpers);
  }

  ngOnInit(): void {
    this.setTitle('Aggiungi template utente');
    this.addMod = true;
    this.populateSelect();
    this.isInserimento(true);
  }


  getTemplateUtente() {
    return this.templateUtente;
  }

  getRequest(request: TemplateUtenteProfilo) {
    console.log('add request',request)
    this.operationService.addTemplateUtente(this.urlInsert, request).subscribe(response => this.datiTemplateUtente(response));
  }

  getRequestAddUtente(request: TemplateUtenteProfilo) {
        console.log('add request utente',request)
      this.operationService.addUtenteProfilo(this.urlInsert,  new UtenteProfiloRequest(this.utente, request)).subscribe(response => this.datiTemplateUtente(response));
  }

  datiTemplateUtente(response) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(this.templateUtente);
    }
  }

  inizializza(urlInsert: string, utente: UtenteProfilo, templateUtente: TemplateUtenteProfilo) {
    this.templateUtente = JSON.parse(JSON.stringify(templateUtente));
    this.utente = utente;
     //    this.populateSelect();
    this.urlInsert = urlInsert;
    this.createForm();
  }
}
